import request from "../request";
import qs from "qs";
import { sendNationCaptchaName, companyInfo, NODE_API } from "../../config";
import myRequest from "./query";
// 获取token
export const getToken = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/audits/getToken",
      method: "post",
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 获取IP
export const getIp = (params) => {
  return new Promise((resolve, reject) => {
    request({
      url: "/getIp/?format=json&callback=getip",
      method: "get",
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 获取验证码
export const verificationCode = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/audits/verificationCode",
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: localStorage.getItem("token"),
      },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//提交试用申请
export const trialApply = (params = {}) => {
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/trial/apply",
      method: "post",
      data: params,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 后台获取试用接口列表
export const getTrialList = (params = {}) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/trial/getList",
      method: "post",
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 后台获取新闻列表
export const getNewsListHouTai = (params = {}) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/news/getNewsList",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 获取新闻列表
export const listNews = (params = {}) => {
  return new Promise((resolve, reject) => {
    params.status = params?.status === "" ? "" : params?.status || ["1"];
    params.pageSize = params?.pageSize || 1;
    params.pageIndex = params?.pageIndex || 0;
    // const data = qs.stringify(params)
    request({
      url: NODE_API + "/oms/news/getNewsList",
      method: "post",
      data: params,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//获取新闻详情
export const newsDetail = (params = {}) => {
  return new Promise((resolve, reject) => {
    let data =
      typeof params === "string"
        ? qs.stringify({ id: params.substring(5) })
        : qs.stringify(params);
    request({
      url: NODE_API + "/oms/news/getNews",
      method: "post",
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//获取招聘信息列表
export const getRecruitment = (params = {}) => {
  return new Promise((resolve, reject) => {
    let data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/employment/getList",
      method: "post",
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//新增岗位
export const employmentInsertMessage = (params = {}) => {
  return new Promise((resolve, reject) => {
    let data = params;
    request({
      url: NODE_API + "/oms/employment/insertMessage",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//修改岗位
export const modifyMessage = (params = {}) => {
  return new Promise((resolve, reject) => {
    let data = params;
    request({
      url: NODE_API + "/oms/employment/modifyMessage",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 获取七牛云
export const getQiNiuToken = () => {
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/audits/getTokenQiniu",
      method: "post",
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 编辑新闻
export const modifyNews = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/news/modifyNews",
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
      data: params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 新建新闻
export const saveNews = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/news/insertNews",
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
      data: params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 删除新闻
export const deleteNews = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/news/deleteNews",
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: localStorage.getItem("token"),
      },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 删除招聘信息
export const deleteRecruit = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/employment/deleteMessage",
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: localStorage.getItem("token"),
      },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const sendNationCaptcha = (params) => {
  return new Promise((resolve, reject) => {
    params.country = "86";
    params.productName = sendNationCaptchaName;
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/captcha/sendNationCaptcha",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getApplyTransactionCheck = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/transaction/applyTransactionCheck",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getnewsList = (params) => {
  return new Promise((resolve, reject) => {
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/news/getNewsList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 获取招聘信息列表
export const getEmploymentList = (params = {}) => {
  return new Promise((resolve, reject) => {
    params.pageSize = params?.pageSize || 5;
    // 第几页
    params.pageIndex = params?.pageIndex || 0;
    const data = qs.stringify(params);
    request({
      url: NODE_API + "/oms/employment/getList",
      method: "post",
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 增加查看次数接口
export const addBrowseNumber = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/browse/addBrowseNumber",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 获取查看次数接口
export const getBrowseNumber = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/browse/getBrowseNumber",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//新增图片
export const createFile = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/files/createFile",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//删除图片
export const deleteFile = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/files/deleteFile",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//图片列表
export const listFilesByType = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/files/listFilesByType",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

//新增通用内容
export const createModule = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/module/createModule",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data:params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//编辑通用内容
export const updateModule = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/module/updateModule",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data:params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//通用内容列表
export const moduleList = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/module/moduleList",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data:params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
//删除通用内容
export const deleteModule = (params = {}) => {
  const data = qs.stringify(params);
  return new Promise((resolve, reject) => {
    request({
      url: NODE_API + "/oms/module/deleteModule",
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data:params,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
